export enum Permissions {
  // VZO Permissions
  VZO_Apps_Internal = 'vzo.app.internal',
  VZO_Apps_Customer = 'vzo.app.customer',
  VZO_Admin = 'vzo.admin',
  VZO_Dashboard = 'vzo.dashboard',
  VZO_ConstructionSites_Read = 'vzo.cs.r',
  VZO_Observations_Read = 'vzo.obs.r',
  VZO_Observations_Write = 'vzo.obs.w',
  VZO_ClusteredSigns_Read = 'vzo.cls.r',
  VZO_MatchedSigns_Read = 'vzo.ms.r',
}

export const DefaultAadPermissions: Permissions[] = [Permissions.VZO_Apps_Customer]
